export const ReportsPage = [
  {
    path: "/BOMCompareReport",
    component: () => import("@/views/reports/BOMCompar"),
  },
  {
    path: "/BOMReport",
    component: () => import("@/views/reports/BOMReport"),
  },
  {
    path: "/standardReport",
    component: () => import("@/views/reports/standardReport"),
  },
  {
    path: "/scheduleReport",
    component: () => import("@/views/reports/scheduleReport"),
  },
  {
    path: "/projectReport",
    component: () => import("@/views/reports/projectReport"),
  },
  {
    path: "/progressReport",
    component: () => import("@/views/reports/departmentTaskProgressReport.vue"),
  },
];
